module.exports = __webpack_public_path__ + "assets/img/clapperboard.406313d8.png";